import "../../styles/templates/product.scss";

import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';
import { getOmnibusPriceFromAPI, renderOmnibusPriceFromAPI, createOmnibusEndpoint } from '../vendor/omnibus.js';
import RecipientForm from '../components/recipient-form.js'

$(function() {
  $('.product-template').on('variantChange', function (e) {
    if (e.variant) {
      $('[data-variant-sku]').html(e.variant.sku);
    }
  });

  RecipientForm();
});


(function () {
  const renderOmnibusPrice = async function (container, vId = false, vPrice = false, vHasPromo = false) {
    const variantID = vId || container.getAttribute('data-omnibus_id');
    const variantPrice = vPrice || container.getAttribute('data-variant_price');
    const brand = container.getAttribute('data-omnibus_brand');
    const hasPromo = vHasPromo || container.getAttribute('data-has_promo');

    renderOmnibusPriceFromAPI(container, await getOmnibusPriceFromAPI(brand, variantID), variantPrice, hasPromo);
  }

  const getOBContainers = function () {
    const omnibusContainers = document.querySelectorAll('[data-omnibus_price-container]');
    const OBContainersByEndpoint = {}

    if (omnibusContainers && omnibusContainers.length) {
      const OBContainers = Array.prototype.slice.call(omnibusContainers);

      OBContainers.map(container => {
        const currentID = container.getAttribute('data-omnibus_id');
        const currentBrand = container.getAttribute('data-omnibus_brand');
        const currentEndpoint = createOmnibusEndpoint(currentBrand, currentID);

        if (!OBContainersByEndpoint[currentEndpoint]) OBContainersByEndpoint[currentEndpoint] = [];
        OBContainersByEndpoint[currentEndpoint].push(container);
      });
    }

    return OBContainersByEndpoint;
  }

  const OBContainersByEndpoint = getOBContainers();

  for (const [endpoint, containers] of Object.entries(OBContainersByEndpoint)) {
    for (let i = 0; i < containers.length; ++i) {
      renderOmnibusPrice(containers[i]);
    }
  }

  const productTemplateSection = document.getElementById('ProductSection--template_product');
  if (productTemplateSection) {
    productTemplateSection.addEventListener('variantChange', function (e) {
      if (e.variant) {
        const OBContainersByEndpoint = getOBContainers();

        for (const [endpoint, containers] of Object.entries(OBContainersByEndpoint)) {
          for (let i = 0; i < containers.length; ++i) {
            renderOmnibusPrice(containers[i], e.variant.id, e.variant.price);
          }
        }
      }
    });
  }
})();
